const _titleizeWord = string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}
export const capitalize = (str, lower = false) =>
  (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase())

export const titleize = sentence => {
  if (!sentence.split) {
    return _titleizeWord(sentence)
  }
  const result = []
  sentence.split('_').forEach(w => {
    result.push(_titleizeWord(w))
  })
  return result.join('')
}



// WEBPACK FOOTER //
// ./src/helper/index.js